module.exports = __webpack_public_path__ + "img/explicacao6.118eddc0.png";